import { skipWindow } from "utils/helper/array";

type InitOptions = {
  visibleSaveButton?: boolean;
  visiblePrintButton?: boolean;
  highlightText?: string;
};

type PdfViewerApplication = {
  initializedPromise?: Promise<void>;
  eventBus?: { dispatch: (eventName: string, data: unknown) => void };
};

// PDFテキストレイヤーは長文だと検索にヒットしないため40文字で分割
const normalizeHighlightText = (highlightText?: string) =>
  skipWindow(
    highlightText?.replaceAll("\\n", "").split("") ?? [],
    40,
    false
  ).map(s => s.join(""));

export const buildViewerUrl = (source: string) =>
  `/public/pdfjs-5.1.91-dist/web/viewer.html?file=${encodeURIComponent(
    source
  )}`;

export default class PDFJs {
  init(source: string, element: HTMLDivElement, options: InitOptions = {}) {
    const iframe = document.createElement("iframe");
    const queries = normalizeHighlightText(options.highlightText);

    iframe.src = buildViewerUrl(source);
    iframe.width = "100%";
    iframe.style.border = "none";

    const styleRules = [
      ".textLayer .highlight { --highlight-selected-bg-color: var(--highlight-bg-color); --highlight-selected-backdrop-filter: var(--highlight-backdrop-filter); }",
      ".xfaLayer .highlight.selected { background-color: rgb(239 203 237) !important; }"
    ];

    const hiddenSelectors: string[] = [];
    if (!options.visibleSaveButton) {
      hiddenSelectors.push("#downloadButton", "#secondaryDownload");
    }
    if (!options.visiblePrintButton) {
      hiddenSelectors.push("#printButton", "#secondaryPrint");
    }
    if (hiddenSelectors.length > 0) {
      styleRules.unshift(
        `${hiddenSelectors.join(", ")} { display: none !important; }`
      );
    }

    iframe.addEventListener("load", () => {
      const doc = iframe.contentDocument;
      if (doc?.head) {
        const style = doc.createElement("style");
        (style as Node).textContent = styleRules.join("\n");
        (doc.head as Node).appendChild(style);
      }

      if (queries.length === 0) return;

      const pdfViewerApplication = (iframe.contentWindow as
        | (Window & { PDFViewerApplication?: PdfViewerApplication })
        | null)?.PDFViewerApplication;

      if (
        !pdfViewerApplication?.initializedPromise ||
        !pdfViewerApplication.eventBus
      ) {
        return;
      }

      void pdfViewerApplication.initializedPromise.then(() => {
        pdfViewerApplication.eventBus?.dispatch("find", {
          source: pdfViewerApplication,
          type: "",
          query: queries,
          caseSensitive: false,
          entireWord: false,
          highlightAll: true,
          findPrevious: false,
          matchDiacritics: true
        });
      });
    });

    ((element as unknown) as Node).appendChild(iframe);
  }
}
